<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'gestoesDeAulas.planosInfantil' })"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Plano Mensal Infantil
        </h1>
      </v-col>
    </v-row>

    <v-row justify="center">
      <v-col cols="12" sm="10" md="12" lg="12">
        <v-card>
          <v-card-title>
            <v-row justify="space-between">
              <v-col cols="12" sm="6" md="6" lg="6">
                <h2>Plano de Aula</h2>
              </v-col>
              <v-col cols="12" sm="6" md="6" lg="6" class="text-right">
                <v-btn
                  v-if="plano.path"
                  color="primary"
                  x-small
                  text
                  @click="[visualizarPlanoAnexado(plano.id), (dialogInfantil = true)]"
                >
                  <v-icon left>fa fa-file-pdf-o</v-icon>
                  Visualizar Plano anexado
                </v-btn>
                <v-btn
                  color="primary"
                  x-small
                  text
                  @click="() => [visualizarPdf(plano.id), (dialog = true)]"
                >
                  <v-icon left>fa fa-file-pdf-o</v-icon>
                  Visualizar PDF
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <label for="">Professor</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.professor
                    ? plano.gestao_de_aula.professor.nome
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Turma</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.turma
                    ? plano.gestao_de_aula.turma.descricao
                    : "- - -"
                  : "- - - "
              }}
            </v-input>

            <label for="">Componente Curricular</label>
            <v-input>
              {{
                plano.gestao_de_aula
                  ? plano.gestao_de_aula.disciplina
                    ? plano.gestao_de_aula.disciplina.descricao
                    : "- - - "
                  : "- - - "
              }}
            </v-input>

            <label for="">Data lançamento</label>
            <v-input>
              <v-chip>
                {{
                  plano.created_at
                    ? plano.created_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>

            <label for="">Ultima atualização</label>
            <v-input>
              <v-chip>
                {{
                  plano.updated_at
                    ? plano.updated_at.substr(0, 10).split("-").reverse().join("/")
                    : "- - - "
                }}
              </v-chip>
            </v-input>
            <v-combobox v-model="seriesSelecionadas" chips label="Series" multiple readonly />
          </v-card-text>
        </v-card>

        <v-card class="mt-5">
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="4">
                <label for="">Status</label>
                <e-situacao-plano-infantil :plano="plano" v-on:update="listarPlano" />
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label>Objetivos de aprendizagem e desenvolvimento </label>
                <v-list-item v-for="(objetivo, i) in objetivosSelecionados" :key="i">
                  <li>
                    {{ objetivo ? objetivo.descricao : "- - -" }}
                  </li>
                </v-list-item>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label>Campos de experiência </label>
                <v-list-item v-for="(experiencia, i) in experienciasSelecionadas" :key="i">
                  <li>
                    {{ experiencia ? experiencia : "- - -" }}
                  </li>
                </v-list-item>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">EIXOS TEMÁTICOS</label>
                <v-input color="primary">
                  {{ plano.eixos_tematicos ? plano.eixos_tematicos : "- - - " }}
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>

                <label for="">DIREITOS DE APRENDIZAGEM</label>
                <v-input>
                  {{ plano.direitos_aprendizagem ? plano.direitos_aprendizagem : "- - - " }}
                </v-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col>
                <v-divider></v-divider>
                <label for="">METODOLOGIA, RECURSOS E AVALIAÇÃO</label>
                <v-input filled rounded dense color="primary">
                  {{
                    plano.metodologia_recursos_avaliacao
                      ? plano.metodologia_recursos_avaliacao
                      : "- - -"
                  }}
                </v-input>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <ModalCarteira :dialog.sync="dialog" :pdf="pdf" />
    <ModalCarteiraInfantil :pdf="pdfInfantil" :dialog.sync="dialogInfantil" />
  </main-template>
</template>

<script>
import ModalCarteira from "@/components/Matriculas/EModalCarteira.vue";
import ModalCarteiraInfantil from "@/components/Matriculas/EModalCarteiraInfantil.vue";

export default {
  components: {
    ModalCarteira,
    ModalCarteiraInfantil,
  },
  data() {
    return {
      dialog: false,
      pdf: null,
      showSnackbar: false,
      plano: {},
      plano_id: null,
      seriesSelecionadas: [],
      experienciasSelecionadas: [],
      objetivosSelecionados: [],
      recursosSelecionados: [],
      duvidasSelecionadas: [],
      dialogInfantil: false,
      pdfInfantil: null,
    };
  },
  async mounted() {
    this.getId();
    await this.listarPlano(this.pageNumber);
  },
  methods: {
    async getId() {
      const { id } = this.$route.params;
      this.plano_id = id;
    },
    async listarPlano() {
      this.$loaderService.open("Carregando Plano");
      try {
        const { data } = await this.$services.planosService.showInfantil(this.plano_id);

        this.plano = { ...data.planoBimestralInfantil };
        this.seriesSelecionadas = this.plano.gestao_de_aula.turma.series.map((s) => s.descricao);

        this.objetivosSelecionados = [...data.objeto_aprendizagem];
        this.experienciasSelecionadas = Array.isArray(data.planoBimestralInfantil.experiencia)
          ? [...data.planoBimestralInfantil.experiencia]
          : [];
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.$loaderService.close();
      }
    },
    async carregarDadosAoAtualizarStatus() {
      try {
        this.listarPlano();
      } catch (error) {
        this.$handleError(error);
      }
    },
    async visualizarPdf(planoId) {
      this.pdf = await this.$services.planosService.pdfInfantil(planoId);
    },
    async visualizarPlanoAnexado(planoId) {
      this.pdfInfantil = await this.$services.planosBimestraisInfantilService.planoAnexado(planoId);
    },
  },
};
</script>

<style></style>
